import { marketsConfig } from './config';
import {
  ensureTrailingSlash,
  getLanguagePrefixForMarket,
  removeLeadingSlash,
} from './link-helper';
import { AlternativeLink, Language, Market } from './types';

export const fullAlternativeLinks = (links: AlternativeLink[]) =>
  links.map((l) => {
    const domain = ensureTrailingSlash(localeBaseUrl(l.locale));
    const href = removeLeadingSlash(l.href);

    return {
      locale: l.locale,
      href: ensureTrailingSlash(domain + href),
    };
  });

export const localeBaseUrl = (locale: string, domainOnly = false): string => {
  const elements = locale.split('-');
  const lang = elements[0] as Language;
  const market = elements[1] as Market;

  const marketCfg = marketsConfig[market];

  const langData = marketCfg?.languages.find((l) => l.code === lang);

  if (!langData || !langData.domain) {
    throw new Error(`[ERROR] missing language and domain for ${locale}`);
  }

  const langPrefix = getLanguagePrefixForMarket(market, lang);

  if (langPrefix && !domainOnly) {
    return ensureTrailingSlash(langData.domain + langPrefix);
  }

  return langData.domain;
};
